<template>
    <el-container v-loading="loading">
        <el-main>
            <div class="Row" style="margin: 1vh 0">
                <div class="backlog bulletin-board box-background">
                    <div class="box-title">{{$t('comm.KeyIndicator')}}</div>
                    <div style="display: flex;width: 100%;justify-content: center;">
                        <div class="info-box">
                            <span class="box-label">{{ $t('Default.NumOfNewOrdThisMon') }}</span>
                            <span class="box-number">
                                    {{ OrderNumber.materialNum }}
                                </span>
                        </div>
                        
                        <div class="info-box">
                            <span class="box-label">{{ $t('Default.NumOfShipped') }}</span>
                            <span class="box-number">
                                    {{ OrderNumber.disCount }}
                                </span>
                        </div>
                    </div>
                </div>
                <div class="backlog download-board box-background">
                    <span class="box-title">{{ $t('Default.TheTips') }}</span>
                    <div style="width:95%;display:flex;justify-content: center;">
                        <div class="info-box">
                        <span class="box-label">{{ $t('Default.PendingOrder') }}</span>
                        <span class="box-number">
                                {{ backlog.unValidCount }}
                            </span>
                        </div>
                        <div class="info-box">
                        <span class="box-label">{{ $t('Default.NumOfUnShip') }}</span>
                        <span class="box-number">
                                {{ backlog.unOutCount }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="Row">
                <bulletin class="bulletin-board box-background" :formData="Bulletin" :type="'Bulletin'" :morebtn="bulletinbtn"
                    :viewmore="bulletinmore">
                </bulletin>
                <bulletin class="download-board box-background" :formData="Download" :type="'Download'" :morebtn="downloadbtn"
                    :viewmore="downloadmore">
                </bulletin>
            </div>

        </el-main>
    </el-container>
</template>

<script>
import bulletin from "@/components/BulletinBoard"
import XElTooltip from '@/components/X-el-tooltip.vue'
import { getThisMonth } from "@/utils/utils"
export default {
    components: {
        bulletin, XElTooltip
    },
    data() {
        return {
            loading: false,
            OrderNumber: {
                materialNum: 0,
                disCount: 0,
                refundOrder: 0
            },
            backlog: {
                unValidCount: 0,
                unOutCount: 0,
                refundOrder: 0
            },
            infomorebtn:true,
            bulletinbtn:true,
            downloadbtn:true,
            Download: [],
            Bulletin: [],
            Information: [],

        }
    },
    methods: {
        downloadmore() {
            this.$router.push({
                path: "/Home/SortFile",
            })
        },
        bulletinmore() {
            this.$router.push({
                path: "/Home/BulletinCenter",
            })
        },
        informmore() {
            this.$router.push({
                path: "/Home/Information",
            })
        },
        async pageLoad() {
            // var options = {background:"rgba(0,0,0,0)"}
            // let loadinstance = Loading.service(options);
            this.loading = true;
            await this.asyncaxiosInvoke("/AgencyComm/Handler/VueSysHandler.ashx?",
                { action: 'gethomebulletin' },
                (res) => {
                    var allinform = eval(res.data);
                    console.log(1);
                    for (let i = 0; i < allinform[0].length; i++) {
                        allinform[0][i].text = "["+allinform[0][i].CateName+"]" + allinform[0][i].text;
                        allinform[0][i].isnew = eval(allinform[0][i].isnew);
                        allinform[0][i].date = allinform[0][i].date.substring(0, 10);

                    }
                    for (let j = 0; j < allinform[1].length; j++) {
                        allinform[1][j].text = "["+allinform[1][j].CateName+"]" + allinform[1][j].text;
                        allinform[1][j].date = allinform[1][j].date.substring(0, 10);
                        allinform[1][j].isnew = eval(allinform[1][j].isnew);
                    }
                    var data = allinform[0].concat(allinform[1]);
                    data = data.sort((a, b) => {
                        return b.updatetime - a.updatetime;
                    });
                    console.log(data);
                    if(data.length<5)this.bulletinbtn = false;
                    this.Bulletin = data;
                });

            this.axiosInvoke("/AgencyComm/Handler/VueSysHandler.ashx?",
                { action: 'getnewdownload' },
                (res) => {
                    console.log(2)
                    var newdownload = eval(res.data);
                    if(newdownload.length<5)this.downloadbtn = false;
                    this.Download = newdownload;
                });
                
            this.axiosInvoke("/AgencyComm/Handler/VueSysHandler.ashx?",
                { action: "gethomenumber"},
                (res) => {
                    var data = eval(res.data);
                    this.OrderNumber.materialNum = data.materialNum;
                    this.OrderNumber.disCount = data.disCount;
                    this.backlog.unValidCount = data.unValidCount;
                    this.backlog.unOutCount = data.unOutCount;
                })
            // this.axiosInvoke("/AgencyComm/Handler/VueSysHandler.ashx?", {
            //     action: "getallinformation",
            //     loadMore:false, // 首页消息区不需要全部加载，通过此属性控制查询过账表时不触发全部遍历数据
            //     pageindex:0,
            //     pagesize: 4
            // }, (res) => {
            //     var data = eval(res.data);
            //     data.shift();
            //     if(data.length <4)this.infomorebtn = false;
            //     data.forEach(v => {
            //         switch (v.Oppo) {
            //             case 0://生效
            //                 switch(v.FromSourceTag){
            //                     case 2601:
            //                         v.name = this.$t("Default.haveaneworder").replace("{0}", v.FromBillNo);
            //                     break;
            //                     case 20021:
            //                         v.name = this.$t("Default.haveqmabnqlyorder").replace("{0}", v.FromBillNo);
            //                     break;
            //                 }
            //             break;
            //             case 1://变更 
            //                 switch(v.FromSourceTag){
            //                     case 2601:
            //                         v.name = this.$t("Default.haveanewchange").replace("{0}", v.FromBillNo);
            //                     break;
            //                 }
            //             break;
            //             case 2://结案
            //                 switch(v.FromSourceTag){
            //                     case 2601:
            //                         v.name = this.$t("Default.orderendcase").replace("{0}", v.FromBillNo);
            //                     break;
            //                 }
            //             break;
            //             case 3://图纸变更
            //                 v.name = this.$t('comm.order') + "[" + v.FromBillNo + "]" + this.$t('Default.printhavenew');
            //             break;
            //             case 4://企业自行变更交期
            //                 v.pageType='purTrackMatRecord';
            //                 v.name = this.$t("Default.ConfirmState0").replace("{0}", v.FromBillNo);
            //                 v.ConfirmState=0;//交期变更处理状态：未变更
            //             break;
            //             case 5://同意交期变更
            //                 v.pageType='purTrackMat';
            //                 v.name = this.$t("Default.ConfirmState3").replace("{0}", v.FromBillNo);
            //                 v.ConfirmState=3;//交期变更处理状态：已变更
            //             break;
            //             case 6://不同意交期变更
            //                 v.pageType='purTrackMat';
            //                 v.name = this.$t("Default.ConfirmState2").replace("{0}", v.FromBillNo);
            //                 v.ConfirmState=2;//交期变更处理状态：不同意变更
            //             break;
            //         }
            //         if(typeof(v.pageType) != 'undefined' && (v.pageType == 'purTrackMat' || v.pageType == 'purTrackMatRecord')) {
            //             this.Information.push({PushId:v.PushId,pageType:v.pageType,text:v.name,date:v.PushTime,billno:v.FromBillNo,confirmState:v.ConfirmState,Oppo:v.Oppo});
            //         }
            //         else  {
            //             this.Information.push({PushId:v.PushId,text:v.name,date:v.PushTime,billno:v.FromBillNo,sourcetag:v.FromSourceTag,Oppo:v.Oppo});
            //         }
            //     });
            // })
            // loadinstance.close();
            this.loading = false;
        }
    },
    created() {
        this.pageLoad();
    },

}
</script>
<style scoped>
::v-deep .el-container {
    min-width: 1440px;
}

.el-container /deep/ .el-main {
    margin: 0;
    background-color: #e9e9e9;
}

::v-deep .el-main {
    margin: 0;
    padding: 0;
}

.header-container {
    width: 96.8%;
    margin: 1vh 1.6%;
    display: flex;
    flex-wrap: wrap;
    height: 23vh;
    background-image: url(@/assets/img/MainPage/headerinfo.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: bottom;
}
.header-container .info-box:last-child{
    border: none;
}
.header-container .info-box:first-child{
    margin-left: 20px;
}
.info-box {
    display: flex;
    flex-wrap: wrap;
    width: 18%;
    min-width: 200px;
    max-width: 300px;
    margin-bottom: 3vh;
    border-right: solid 1px #e9e9e9;
    
}
.backlog .info-box{
    width: 33%;
    margin-bottom: 10vh;
}
.info-link:hover {
    cursor: pointer;
    color: #3466cc;
}

.backlog .info-box:last-child{
    border: none;
}
.box-label {
    text-align: center;
    font-size: 1.1rem;
    width: 100%;
}

.box-number {
    text-align: center;
    font-size: 1.8rem;
    font-weight: bold;
    width: 100%;
}
.box-Link{
    cursor: pointer;
}

::v-deep .el-header {
    padding: 0;
    margin: 0;
}

.Row {
    width: 100%;
    display: flex;
    margin-bottom: 1.5vh;
}

.backlog {
    display: flex;
    flex-wrap: wrap;
    width: 55.5%;
    height: 33vh;
    /* max-height: 11.2rem; */
    margin: 0 0.8% 0 1.6%;

}

.box-background {
    background-image: url(@/assets/img/MainPage/backlog.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: bottom;
}

.backlog .box-number {
    border: none;
}

.backlog .box-label {
    font-size: 17px;
}

.box-title {
    margin: 2vh 0 0 1.5vw;
    text-align: left;
    font-size: 1.3rem;
    width: 100%;
}

.message-board {
    padding-top: 1vh;
    width: 40%;
    height: 32vh;
    /* max-height: 11.2rem; */
    margin: 0 1.6% 0 0.8%;
}
.message-board /deep/ .el-card .el-card__body .card-message-empty{
    margin: 60px 0;
}
.download-board,.bulletin-board {
    padding-top: 1vh;
    height: 31vh;
}
.download-board /deep/ .el-card .el-card__body .inform-row,.bulletin-board /deep/ .el-card .el-card__body .inform-row{
    padding:1.6vh 0;
}
.bulletin-board{
    width: 55.5%;
    margin: 0 0.8% 0 1.6%;
}
.download-board{
    width: 40%;
    margin: 0 1.6% 0 0.8%;
}
@media screen and (max-height: 900px) {
    .backlog{
        height: 30vh;
    }
    .message-board{
        height: 29vh;
    }
    .download-board,.bulletin-board {
    padding-top: 1vh;
    height: 30vh;
    }
    .download-board /deep/ .el-card .el-card__body .inform-row,.bulletin-board /deep/ .el-card .el-card__body .inform-row{
    padding:1.2vh 0;
    }
}
</style>